import styles from '../AgenticAnnotationTaskUI.module.less'
import { MCPTool } from 'Types/Tasks.types'
import EmptyIcon from 'Assets/icons/empty-icon.svg'
import Flex from 'antd/lib/flex'
import Dropdown from 'antd/lib/dropdown/dropdown'
import Button from 'antd/lib/button'
import { useMemo } from 'react'
import { ItemType } from 'antd/lib/menu/interface'

const EmptyContent = (props: { mcpTools: MCPTool[]; onSelectTool: (toolName: string) => void }) => {
    const { mcpTools, onSelectTool } = props
    const mcpToolsContent: ItemType[] = useMemo(() => {
        return mcpTools.map(tool => ({
            label: tool.name,
            value: tool.name,
            type: 'item',
            key: tool.name,
            onClick: () => onSelectTool(tool.name),
        }))
    }, [mcpTools, onSelectTool])

    return (
        <Flex
            vertical
            align="center"
            justify="center"
            className={styles['empty-content-container']}
        >
            <img className={styles['empty-icon']} src={EmptyIcon} alt="Empty" />
            <p className={styles['empty-heading']}>No tool call found</p>
            <p className={styles['empty-caption']}>Start adding tool calls from the below option</p>

            <Dropdown
                menu={{
                    items: mcpToolsContent,
                }}
                trigger={['click']}
                placement="bottom"
            >
                <Button className={styles['add-tool-call-button']}>Add Tool Call</Button>
            </Dropdown>
        </Flex>
    )
}

export default EmptyContent
